import React, { ComponentProps } from 'react';
import Product from '../../graphql/entities/product/Product';
import BlurTextField, {
  BlurTextFieldType,
  IBlurTextFieldProps,
} from '../../components/connectedForm/BlurTextField/BlurTextField';
import { IDropdownProps } from '../../@types/dropdown';
import * as input from '../../components/connectedForm/inputComponents';
import { IProductFormProps, ProductHeader, ProductReferenceField } from './ProductForm';
import { default as Form } from '../../components/connectedForm';

export const FreeTypeForm = (props: IProductFormProps) => {
  const { values, referenceFormatInUse } = props;

  return (
    <Form.FormContainer ignoreClickOutside data-testid={props['data-testid'] ?? 'product-mini-form-container'}>
      <ProductHeader {...(props as unknown as ComponentProps<typeof ProductHeader>)} />
      <Form.Form>
        <Form.TabPanel formName={Product.type}>
          <Form.TabContent id="main" label="General">
            <Form.Row>
              <Form.Fieldset cols={1 / 2}>
                <Form.Legend label="Product Information" />
                <ProductReferenceField values={values} referenceFormatInUse={referenceFormatInUse} />
              </Form.Fieldset>
              <Form.Fieldset cols={1}>
                <Form.Field<IBlurTextFieldProps>
                  labelCols={1 / 8}
                  inputCols={7 / 8}
                  dataid="description"
                  component={BlurTextField}
                  label="Description"
                  autoFocus={true}
                  type={BlurTextFieldType.ExpandableTextArea}
                />
                <Form.Field<IBlurTextFieldProps>
                  labelCols={1 / 8}
                  inputCols={7 / 8}
                  dataid="salesDescription"
                  component={BlurTextField}
                  label="Sales Description"
                  autoFocus={true}
                  type={BlurTextFieldType.ExpandableTextArea}
                />
                <Form.Field<IDropdownProps>
                  dataid="productClass"
                  component={input.Dropdown}
                  label="Product Class"
                  labelCols={1 / 8}
                  inputCols={3 / 8}
                  readOnly={values.id}
                />
              </Form.Fieldset>
            </Form.Row>
          </Form.TabContent>
        </Form.TabPanel>
      </Form.Form>
    </Form.FormContainer>
  );
};
